import { Inject, Injectable } from '@angular/core';
import {
  BackendDataSourceService,
  BusinessItem,
  CoreConfig,
  CoreConfigService,
  HttpService,
  ViewData
} from '@ntap/core';
import { Observable, of } from 'rxjs';

@Injectable()
export class InMemoryDataSourceService extends BackendDataSourceService {
  constructor(
    httpService: HttpService,
    @Inject(CoreConfigService) config: CoreConfig
  ) {
    super(httpService, config);
  }

  override getViewData(
    viewName: string,
    viewState: any & { $pagingLimit?: number; $pagingOffset?: number }
  ): Observable<ViewData> {
    if (
      Object.hasOwn(viewState, '$pagingLimit') ||
      Object.hasOwn(viewState, '$pagingOffset')
    ) {
      throw new Error(
        'InMemoryDataSourceService can only be used with client side paged lists!'
      );
    }
    return super.getViewData(viewName, viewState);
  }

  override saveViewData<T>(
    viewName: string,
    viewData: BusinessItem
  ): Observable<T> {
    return of(viewData.data); // save se radi preko parenta, dakle DataSource nije zaduzen da spremi item
  }

  override deleteViewData<T>(
    viewName: string,
    viewState: object | object[]
  ): Observable<T> {
    if (viewState instanceof Array) {
      // brisanje se radi preko parent forme, dakle DataSource nije zaduzen da ga obrise
      return of(viewState[0] as any);
    }
    return of(viewState as any);
  }
}
